import KunLoading63 from './src/index'

KunLoading63.install = function (Vue) {
	Vue.component(KunLoading63.name, KunLoading63);
}

export default KunLoading63;
